export type PromoMockTrack = {
  id: string;
  mediafileId: string;
  title: string;
  campaignTitle: string;
  status: 'active' | 'stopped';
  audioUrl: string;
};

export const PROMO_MOCK_PAGE_SIZE = 20;
// The exact reviewed Figma state uses 22 promo clips. This still gives the
// fixed-size list an off-screen second page for virtualization coverage.
export const PROMO_MOCK_TOTAL_COUNT = 22;
// Keep the UI-only fixture loading state observable long enough for Figma
// evidence. The backend-integration task replaces this adapter and its delay.
export const PROMO_MOCK_LOADING_DELAY = 1200;

// The UI-only fixture must also play on a feature branch deployed to stage.
// This is the loudnorm source of local Mediafile #1139912; its stage CDN URL
// was checked with a HEAD request and a 1 KiB Range response on 2026-08-05.
// The backend-integration task removes this fixture adapter altogether.
export const PROMO_MOCK_STAGE_MEDIAFILE_ID = '1139912';
export const PROMO_MOCK_STAGE_AUDIO_URL = 'https://f.stage.muzlab.ru/a4gpurj0d56f_loudnorm.mp3';

const PROMO_TITLES = [
  '7005 Копеечка.mp3',
  '7001 Копеечка.mp3',
  '2001 Копеечка 2-15.03 2.mp3',
  'Летнее предложение.mp3',
  'Сезонная акция.mp3',
  'Обновление ассортимента.mp3',
];

const CAMPAIGN_TITLES = [
  'Доброном_РК_7005 сертификат копеечка',
  'Доброном_РК_7001 копеечка акция',
  'Доброном_РК_2001 копеечка',
  'Специальные предложения',
  'Осенняя кампания',
  'Музыка в зале',
];

export const PROMO_MOCK_TRACKS: PromoMockTrack[] = Array.from({ length: PROMO_MOCK_TOTAL_COUNT }, (_, index) => ({
  id: `promo-mock-${index + 1}`,
  mediafileId: index % 2 === 0 ? PROMO_MOCK_STAGE_MEDIAFILE_ID : `mediafile-mock-${index + 1}`,
  title: index < PROMO_TITLES.length ? PROMO_TITLES[index] : `Проморолик ${index + 1}.mp3`,
  campaignTitle: CAMPAIGN_TITLES[index % CAMPAIGN_TITLES.length],
  status: index % 5 === 2 ? 'stopped' : 'active',
  audioUrl: PROMO_MOCK_STAGE_AUDIO_URL,
}));

export const getPromoMockPage = (offset: number): Promise<PromoMockTrack[]> =>
  new Promise((resolve) => {
    window.setTimeout(() => {
      resolve(PROMO_MOCK_TRACKS.slice(offset, offset + PROMO_MOCK_PAGE_SIZE));
    }, PROMO_MOCK_LOADING_DELAY);
  });
